import React, { useContext, useEffect, useRef, useState } from "react";

import { Button } from "antd";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";
import { Grid } from "antd";
import { LeadButtons } from "../LeadButtons/web";
import cookie from "js-cookie";
import { isValidCharactersXSS, isValidEmail } from "../../../../Utils/Functions";
import { useContact } from "../hook";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { useUser } from "../../../User/User.hook";
import getConfig from "next/config";
import { ModalState, ModalStatus } from "./type";
import IcBuscaPorTi from "shared-components/Components/PopUps/IcBuscaPorTi/web";
import { QuestionIcon } from "shared-components/Components/CustomIcons/QuestionIcon/web";
import "./styles.less";
import CheckboxCustomInput from "shared-components/Components/CheckboxCustomInput";
import { SimilarsLeadsModal } from "../SimilarLeadsModal/SimilarLeadsModal";
import { UserStateContext } from "shared-components/Contexts/User/context";
import dynamic from "next/dynamic";
import Mandatory from "shared-components/Components/User/Mandatory/web";
import { CountriesDropdown } from "shared-components/Components/Dropdowns/CountriesDropdown/web";
import { CountryCode, isValidPhoneNumber, parsePhoneNumberWithError } from "libphonenumber-js";
import { phoneStartWithIndicative } from "@Utils/phones";
import { getInitCountryCode, getInitialContactForm } from "../LeadButtons/PhoneButton/web";
import { MessageIcon } from "shared-components/Components/CustomIcons/MessageIcon/web";

const Modal = dynamic(
	() => import("shared-components/Components/Modal/web").then(mod => mod.Modal),
	{ ssr: false }
);

const { NODE_ENV } = getConfig().publicRuntimeConfig;

const { useBreakpoint } = Grid;

export const TextForm = ({
	id,
	onComplete = null,
	mode,
	disabled = false,
	defaultMessage = "",
	isInListing = false,
	showCTA = false,
	onlyConsult = false,
	queryRouter,
	isProjectSpecialPage = false,
	slug = "",
	projectId = null,
	isFromPaidTraffic = null,
	isProject = false,
	owner = null,
	isFromModal = false,
	propertyLink = undefined
}) => {
	const Router = useRouter();
	const [dataModal, setDataModal] = useState({
		name: "",
		phone: "",
		email: "",
		fincatyc: false,
	});
	const [selectedCountryCode, setSelectedCountryCode] = useState<{
		code: CountryCode;
		value: string;
	}>({
		// This code should be a setting, depending the website
		code: "CO",
		value: "+57",
	});
	const {
		isLoggedIn,
		user: { refetch },
		user,
	} = useUser();
	const { country_code, site_name, main_domain } = useContext(ConfigStateContext);
	const bell = useRef(null);
	const [modalState, setModalState] = useState<ModalStatus>({
		similarModal: ModalState.DEFAULT,
		contactLead: ModalState.DEFAULT,
	});
	const [isLoading, setIsLoading] = useState(false);
	const [formType, setFormType] = useState<number>(0);
	const { loginBasePath } = getConfig().publicRuntimeConfig;
	const [show, setShow] = useState(false);
	const [formData, setFormData] = useState({
		name: "",
		phone: "",
		email: "",
		message: defaultMessage,
		fincatyc: false,
		busca_por_ti: false,
		isProject: false,
		projectId: "",
	});
	const [errors, setErrors] = useState({
		name: false,
		phone: false,
		email: false,
		message: false,
		fincatyc: false,
	});
	const nameRef = useRef<HTMLInputElement>(null);
	const phoneRef = useRef<HTMLInputElement>(null);
	const emailRef = useRef<HTMLInputElement>(null);
	const messageRef = useRef<HTMLTextAreaElement>(null);
	const [userHasAllData, setUserHasAllData] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [fieldToAsk, setFieldToAsk] = useState(0);
	const currentUser = useContext(UserStateContext);

	const handleClickShowNotification = async ({
		type = "success",
		message = "",
		description = "",
	}) => {
		const { showNotification } = await import(
			"shared-components/Components/CustomNotification/web"
		);
		showNotification(type, message, description);
	};

	// Simula el click de CTA "Avisame cuando baje de precio"
	useEffect(() => {
		setTimeout(() => {
			if (queryRouter && queryRouter === "bell") {
				if (bell.current) bell.current.click();
			} else if (queryRouter && queryRouter === "mailConsulta") {
				doContactMutation(99); //numero random para que envie el mensaje default en backend
			}
		}, 3000);
	}, [queryRouter]);

	useEffect(() => {
		if (country_code !== "CO") {
			setUserHasAllData(true);
		}
		if (country_code === "CO" && currentUser.me) {
			const hasAllData = !!currentUser.me.phone && !!currentUser.me.name;
			setUserHasAllData(hasAllData);
		}
	}, [currentUser.me]);

	const openModal = (type: number = 0) => {
		setFormType(type);
		setModalState(prevState => ({ ...prevState, similarModal: ModalState.OPEN }));
	};

	const screen = useBreakpoint();

	const {
		sendContact,
		resetForm,
		error,
		formCompleted,
		disabledEmail,
		dataRegisterMutation,
		dataUserExist,
		doContactMutation,
		loading: contactLoading,
		isSendedConsultation,
	} = useContact({
		id,
		onComplete: openModal,
		type: "lead",
		mode,
		source: isInListing ? 22 : screen.lg ? 0 : 4,
		utm: Router.query,
		env: NODE_ENV == "development" || NODE_ENV == "beta" ? "development" : "production",
	});

	const FP = useFacebookPixel();

	const reset = () => {
		resetForm();

		if (isLoggedIn) {
			setFormData({
				name: user.data?.me?.name ?? "",
				phone: formatPhoneNumber(user.data?.me?.phone ?? ""),
				email: user.data?.me?.email ?? "",
				busca_por_ti: false,
				message: "",
				fincatyc: false,
				isProject: isProject,
				projectId: projectId,
			});
		}

		setIsLoading(false);
	};

	useEffect(() => {
		Router.events.on("routeChangeStart", reset);

		return () => Router.events.on("routeChangeStart", reset);
	}, []);

	useEffect(() => {
		if (user.data && user.data?.me && isLoggedIn) {
			const phone = user.data?.me?.phone || formData.phone;

			try {
				try {
					const parsedPhoneNumber = parsePhoneNumberWithError(phone);
					setSelectedCountryCode({
						code: parsedPhoneNumber?.country,
						value: `+${parsedPhoneNumber?.countryCallingCode}`,
					});
					const data = {
						...formData,
						name: user.data?.me?.name,
						phone: parsedPhoneNumber?.nationalNumber,
						email: user.data?.me?.email,
						isProject: isProject,
						projectId: projectId,
					}
					setFormData(data);
					if (isFromModal) focusEmptyData(data);
				} catch (error) {
					const parsedPhoneNumber = parsePhoneNumberWithError(
						phone,
						selectedCountryCode?.code
					);
					const isValidNumber = isValidPhoneNumber(phone, selectedCountryCode?.code);

					if (isValidNumber) {
						setSelectedCountryCode({
							code: parsedPhoneNumber?.country,
							value: `+${parsedPhoneNumber?.countryCallingCode}`,
						});

						const data = {
							...formData,
							name: user.data?.me?.name,
							phone: parsedPhoneNumber?.nationalNumber,
							email: user.data?.me?.email,
							isProject: isProject,
							projectId: projectId,
						}
						setFormData(data);
						if (isFromModal) focusEmptyData(data);

						console.error(error);
					} else {
						throw new Error("Invalid phone number");
					}
				}
			} catch (error) {
				const data = {
					...formData,
					name: user.data?.me?.name,
					phone: phone,
					email: user.data?.me?.email,
					isProject: isProject,
					projectId: projectId,
				}
				setFormData(data);
				if (isFromModal) focusEmptyData(data);

				console.error(error);
			} finally {
				handleBlur({ target: { value: phone } }, "phone");
			}
		} else {
			const data = {
				...getInitialContactForm(),
				message: defaultMessage,
			};

			setFormData(data);
			if (isFromModal) focusEmptyData(data);
			setSelectedCountryCode(getInitCountryCode());
		}
	}, [user.data, user.data?.me]);

	const formatPhoneNumber = (phone: string) => {
		try {
			const parsedPhoneNumber = parsePhoneNumberWithError(phone);
			return parsedPhoneNumber?.nationalNumber;
		} catch (e) {
			return phone;
		}
	};

	const focusEmptyData = (data) => {
		if (!data?.name?.length && nameRef?.current) {
			nameRef.current.focus();
		} else if (!data?.phone?.length && phoneRef?.current) {
			phoneRef.current.focus();
		} else if (!data?.email?.length && emailRef?.current) {
			emailRef?.current?.focus();
		} else if (!data?.message?.length && messageRef?.current) {
			messageRef?.current?.focus();
		}
	}

	// Aqui capturo los errores de la query de userExistsQuery
	useEffect(() => {
		if (error && error.message.includes("ya se encuentra registrada")) {
			handleClickShowNotification({
				message: error.message,
				type: "error",
			});

			setIsLoading(false);
		}
	}, [error]);

	useEffect(() => {
		if (formCompleted) {
			const categoryName: string = "formulario";

			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		if (dataUserExist) {
			const leadWithoutLogin = true;
			doContactMutation(0, leadWithoutLogin);
			// openAuthModal({
			// 	withPromise: true,
			// 	email: formData.email,
			// })
			// 	.then(_ => {
			// 		setCurrentUser(formData.name, formData.phone);
			// 	})
			// 	.catch(_ => {
			// 		setIsLoading(false);
			// 	});
		}
	}, [dataUserExist]);

	// const setCurrentUser = (name: string, phone: string, type: number = 0) => {
	// 	updateUser({
	// 		name: name,
	// 		phone: phone,
	// 	}).then(_ => {
	// 		doContactMutation(type);
	// 	});
	// };

	const setTypeCTA = (type: number) => {
		doContactMutation(type);
	};

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath,
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	const submitForm = () => {
		if (isFormFilled() && user?.data?.me?.is_terms_and_conditions_accepted || formData.fincatyc) {
			setFormData(prev => ({
				...prev,
				name: prev.name?.trim(),
				message: prev.message?.trim(),
				isFromPaidTraffic: isFromPaidTraffic,
				isSendingConsultation: true,
				isProject: isProject,
				projectId: projectId,
			}));
			sendContact({
				...formData,
				phone: `${selectedCountryCode?.value}${formData.phone}`,
			});

			setIsLoading(true);

			if (isProjectSpecialPage && slug && projectId) {
				let host = window.location.host;
				let TEST_HOST = "xn--4v8h.infocasas.com.uy";
				if (host === TEST_HOST || host === "localhost:3000") {
					host = "beta.infocasas.com.uy";
				}
				let reqEndpoint = `https://${host}/?mid=proyectos&func=landingDinamica&slug=${slug}&formulario&IDproyecto=${projectId}&json&nl`;
				let body = {
					nombre: formData.name,
					email: formData.email,
					tel: `${selectedCountryCode?.value}${formData.phone}`,
					extra: formData.message,
					extra_completo: `${formData.message}.slug:${slug}`,
					InfoLeads: 1,
				};

				fetch(reqEndpoint, {
					method: "POST",
					body: JSON.stringify(body),
				}).then(res => {
					console.log(res);
				});
			}

			setErrors({
				name: false,
				phone: false,
				email: false,
				message: false,
				fincatyc: false,
			});
		} else {
			if (formData.name === "") setErrors({ ...errors, name: true });
			if (formData.email === "") setErrors({ ...errors, email: true });
			if (
				formData.phone === "" ||
				!isValidPhoneNumber(formData?.phone, selectedCountryCode?.code) ||
				phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone)
			)
				setErrors({ ...errors, phone: true });
			if (!user?.data?.me?.is_terms_and_conditions_accepted && !formData.fincatyc)
				setErrors({ ...errors, fincatyc: true });
		}
	};

	const onCancelSimilarsLead = () => {
		setModalState(prevState => ({
			...prevState,
			similarModal: ModalState.CLOSE,
			contactLead: ModalState.CLOSE,
		}));
		if (reset) reset();
		if (onComplete) onComplete();
	};

	const handleShowModal = (e, showModal) => {
		e.preventDefault();
		setShow(showModal);
	};

	const handleBlur = (
		e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
		fieldName: string
	) => {
		const value = e.target.value;
		localStorage.setItem("contactForm", JSON.stringify(formData));
		localStorage.setItem("selectedCountryCode", JSON.stringify(selectedCountryCode));
		if (fieldName === "name") {
			const isValid = value.trim() !== "" && isValidCharactersXSS(value);
			setErrors({ ...errors, name: !isValid });
		} else if (fieldName === "phone") {
			setErrors({
				...errors,
				phone:
					!isValidPhoneNumber(String(value), selectedCountryCode?.code) ||
					phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone),
			});
		} else if (fieldName === "email") {
			const isValid = value.trim() !== "" && isValidEmail(value);
			setErrors({ ...errors, email: !isValid });
		} else if (fieldName === "message") {
			const isValid = value.trim() !== "" && isValidCharactersXSS(value);
			setErrors({ ...errors });
		}
	};

	const isFormFilled = () => {
		if (
			formData.name !== "" &&
			isValidCharactersXSS(formData?.phone) &&
			formData.email !== "" &&
			isValidEmail(formData?.email) &&
			formData.phone !== "" &&
			isValidPhoneNumber(formData?.phone, selectedCountryCode?.code) &&
			!phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone)
		)
			return true;
		else return false;
	};

	const handleCountryChange = value => {
		setSelectedCountryCode(value);
		handleBlur({ target: { value: formData?.phone } }, "phone");
	};

	const handleFincaTYC = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFormData({ ...formData, fincatyc: e.target.checked });
		setErrors({ ...errors, fincatyc: false });
	};

	return (
		<>
			{/* Validar sacar porque no se usa */}
			<Modal show={isModalVisible} onClose={() => setIsModalVisible(false)} height="500px">
				<div className="auth-modal-wrapper">
					<div className="auth-modal">
						<Mandatory
							onOk={() => {
								setTypeCTA(fieldToAsk);
								setIsModalVisible(false);
								setUserHasAllData(true);
								refetch();
							}}
							user={currentUser}
						/>
					</div>
				</div>
			</Modal>
			{/* Validar sacar porque no se usa */}

			{modalState.similarModal == ModalState.OPEN && (
				<SimilarsLeadsModal
					id={id}
					onCancelSimilarsLead={onCancelSimilarsLead}
					onComplete={onComplete}
					setModalState={setModalState}
					reset={reset}
					dataModal={dataModal}
					selectedCountryCode={selectedCountryCode?.value}
					formType={formType}
					setFormType={setFormType}
					mode={mode}
					formData={formData}
					isInListing={isInListing}
					ownerId={owner?.id}
				/>
			)}

			{show && country_code !== "CO" && (
				<IcBuscaPorTi onClose={handleShowModal} showButtons={false} />
			)}

			<form className="contact-form">
				<p style={{ marginTop: ".5rem" }}>
					Completa tus datos para habilitar los medios de contacto
				</p>
				<div className="container-input">
					<input
						ref={nameRef}
						className={"contact-form-input " + (errors.name ? "error" : "")}
						name="nombre"
						placeholder="Nombre y Apellido*"
						disabled={disabled}
						value={formData.name}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							setFormData({ ...formData, name: e.target.value })
						}
						onBlur={e => handleBlur(e, "name")}
						required
					/>
					{errors.name && <span className="error-message">Nombre no válido</span>}
				</div>

				<div className="row">
					<div
						className="container-input"
						style={{ width: "auto" }}>
						<CountriesDropdown
							onChange={handleCountryChange}
							countryCode={selectedCountryCode}
						/>
					</div>
					<div className="container-input" style={{ width: "100%" }}>
						<input
							ref={phoneRef}
							className={"contact-form-input " + (errors.phone ? "error" : "")}
							name="telefono"
							placeholder="Teléfono*"
							disabled={disabled}
							value={formData.phone}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								const phone = e?.target?.value?.replace(/\D/g, "");
								setFormData({
									...formData,
									phone,
								});
								handleBlur({ target: { value: phone } }, "phone");
							}}
							onBlur={e => handleBlur(e, "phone")}
							type="tel"
							required></input>
						{errors.phone && <span className="error-message">Teléfono no válido</span>}
					</div>
				</div>

				<div className="container-input">
					<input
						ref={emailRef}
						className={"contact-form-input " + (errors.email ? "error" : "")}
						name="email"
						type="email"
						placeholder="Email*"
						disabled={disabledEmail || disabled}
						value={formData.email}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							setFormData({ ...formData, email: e.target.value })
						}
						onBlur={e => handleBlur(e, "email")}
						required></input>
					{errors.email && <span className="error-message">Email no válido</span>}
				</div>

				<textarea
					ref={messageRef}
					className={errors.message ? "error" : ""}
					placeholder={"Mensaje"}
					disabled={disabled}
					value={formData.message}
					onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
						setFormData({ ...formData, message: e.target.value })
					}
					onBlur={e => handleBlur(e, "message")}
					required></textarea>
				{errors.message && <span className="error-message">Mensaje no válido</span>}

				{country_code !== "BR" &&
					country_code !== "ce3" &&
					country_code !== "CO" &&
					!isProject && (
						<div className="container-busca-por-ti">
							<input
								className="styled-checkbox"
								type="checkbox"
								value="first_checkbox"
								disabled={disabled}
								id="checkbox-busca-por-ti"
								onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
									setFormData({ ...formData, busca_por_ti: e.target.checked })
								}
							/>
							<label htmlFor="checkbox-busca-por-ti">
								Quiero que {site_name} busque por mí
							</label>

							<button onClick={e => handleShowModal(e, true)} className="info-btn">
								<QuestionIcon width={20} height={20} />
							</button>
						</div>
					)}

				{country_code === "CO" && !user?.data?.me?.is_terms_and_conditions_accepted ? (
					<CheckboxCustomInput
						className="tycfinca"
						value="acceptTYC"
						id="checkboxFincaTyC"
						onChange={handleFincaTYC}
						hasError={errors.fincatyc}>
						Aceptas nuestros{" "}
						<a href="/informacion#terminos-y-condiciones" target="_blank">
							Términos y condiciones
						</a>{" "}
						y{" "}
						<a href="/informacion#politicas-de-privacidad" target="_blank">
							Política de privacidad
						</a>
					</CheckboxCustomInput>
				) : (
					<></>
				)}

				<LeadButtons
					id={id}
					mode={mode}
					disabled={disabled || !isFormFilled()}
					dataModal={formData}
					setDataModal={setFormData}
					queryRouter={queryRouter}
					forceState={modalState.contactLead}
					hasAcceptedTerms={user?.data?.me?.is_terms_and_conditions_accepted || formData.fincatyc}
					onTermsError={() => setErrors({ ...errors, fincatyc: true })}
					propertyLink={propertyLink}
					onPhoneClick={() => {
						setModalState(prevState => ({
							...prevState,
							similarModal: ModalState.OPEN,
							contactLead: ModalState.CLOSE,
						}));
					}}
					onWpClick={() => {
						setModalState(prevState => ({
							...prevState,
							similarModal: ModalState.OPEN,
							contactLead: ModalState.CLOSE,
						}));
					}}
					onlyConsult={onlyConsult}
					owner={owner}
					isProject={isProject}>
					<Button
						type="primary"
						style={{
							backgroundColor: !isFormFilled() ? "#f5f5f5 !important	" : "",
							color: !isFormFilled() ? "rgba(0, 0, 0, .25) !important" : "",
							height: "40px !important",
						}}
						loading={isLoading}
						disabled={formCompleted || disabled || !isFormFilled()}
						icon={<MessageIcon />}
						className="btn-send-lead"
						onClick={submitForm}
					>
						{formCompleted ? "Enviado" : isLoading ? "Enviando" : "Contactar"}
					</Button>
				</LeadButtons>
			</form>
		</>
	);
};

